<script setup lang="ts">
	import { DialogLayout } from "../ui";

	defineProps<{
		title: string;
		text: string;
		cancelText?: string;
		okText?: string;
		loading?: boolean;
	}>();

	const emit = defineEmits<{
		(e: "cancel"): void;
		(e: "confirm"): void;
	}>();
</script>

<template>
	<DialogLayout class="dialog">
		<template #title>
			{{ title }}
		</template>
		<p class="mb-4 break-words whitespace-pre-wrap">{{ text }}</p>
		<template #actions>
			<div class="flex flex-1 justify-between gap-2">
				<button
					class="button button-cancel h-auto min-h-10 w-full text-center"
					@click="emit('cancel')"
				>
					{{ cancelText }}
				</button>
				<button
					:disabled="loading"
					class="button button-primary h-auto min-h-10 w-full text-center"
					@click="emit('confirm')"
				>
					{{ okText }}
				</button>
			</div>
		</template>
	</DialogLayout>
</template>
<style scoped>
	.dialog {
		max-width: 24rem;
	}
</style>
